import { render, staticRenderFns } from "./Ads.vue?vue&type=template&id=3d86d926&scoped=true&"
import script from "./Ads.vue?vue&type=script&lang=js&"
export * from "./Ads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d86d926",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3d86d926', component.options)
    } else {
      api.reload('3d86d926', component.options)
    }
    module.hot.accept("./Ads.vue?vue&type=template&id=3d86d926&scoped=true&", function () {
      api.rerender('3d86d926', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/systemAnalytics/Ads.vue"
export default component.exports